import styled from 'styled-components';

export const TextPercent = styled.h5`
  font-size: ${(props) => props.fontSize};
  color: ${(props) => props.color};
`;

export const GaugeChartBox = styled.div`
  & .gauge-chart {
    & .doughnut {
      & :nth-child(${(props) => props.activeArc}) {
        transform: scale(1.05);
      }
    }
  }
`;

export const GraphLabel = styled.h5`
  font-size: 12px;
  font-style: normal;
  font-weight: bold;
  color: ${(props) => props.theme.colors.darkerblue};
  text-align: center;
`;
